import { makeStyles, createStyles } from "@material-ui/styles";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import Row from "../Row";
import Card from "./Card";

const useStyles = makeStyles(theme =>
  createStyles({
    rowPlaceholder: {
      display: "none",
      alignItems: "center",
      color: theme.palette.text.hint,
    },
    rowRoot: {
      cursor: "pointer",
      "&:hover": {
        background: theme.palette.grey[100],
      },
      "&:hover $rowPlaceholder": {
        display: "flex",
      },
    },
  }),
);

const RowCard = ({
  isOver,
  canDrop,
  cardId,
  groupId,
  slotNo,
  cardContainerId,
  setAnchorEl,
  setAnchorElSlotNo,
}) => {
  const classes = useStyles();

  const toggleRowMenu = useCallback(
    index => event => {
      setAnchorEl(event.currentTarget);
      setAnchorElSlotNo(index);
    },
    [setAnchorElSlotNo, setAnchorEl],
  );

  const cardContainer = useSelector(state =>
    state.getIn([
      "groups",
      groupId?.toString(),
      "cardContainersById",
      cardContainerId?.toString(),
    ]),
  );

  if (!cardContainer) {
    return null;
  }

  return (
    <Row
      isOver={isOver}
      canDrop={canDrop}
      onClick={cardId ? undefined : toggleRowMenu(slotNo)}
      classes={{
        root: classNames({
          [classes.rowRoot]: !cardId,
        }),
      }}
    >
      <Card
        cardId={cardId}
        slotNo={slotNo}
        groupId={groupId}
        cardContainerId={cardContainerId}
        cardContainerType={cardContainer.get("type")}
      />
    </Row>
  );
};

export default RowCard;
